import { render, staticRenderFns } from "./EditLabelsPanel.vue?vue&type=template&id=ff9c72c8&scoped=true&"
import script from "./EditLabelsPanel.vue?vue&type=script&lang=js&"
export * from "./EditLabelsPanel.vue?vue&type=script&lang=js&"
import style0 from "./EditLabelsPanel.vue?vue&type=style&index=0&id=ff9c72c8&prod&lang=scss&scoped=true&"
import style1 from "./EditLabelsPanel.vue?vue&type=style&index=1&id=ff9c72c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9c72c8",
  null
  
)

export default component.exports